const maximumAuthoritySilenceMs = 3000;

/** Socket OPEN is not proof that authoritative state is still arriving.
 * One timer per connection, not per packet; advancing snapshots renew the
 * lease without resetting timers or trusting browser input/render cadence. */
export class RealtimeAuthorityWatchdog {
  private timer = 0;
  private active = false;
  private lastProgressAt = 0;
  private latestTick = -1;
  private latestServerTime = -Infinity;

  public constructor(private readonly expired: () => void) {}

  public start(): void {
    this.stop();
    this.active = true;
    this.lastProgressAt = performance.now();
    this.arm(maximumAuthoritySilenceMs);
  }

  public advance(tick: number, serverTime: number): void {
    if (!this.active || !Number.isSafeInteger(tick) || tick < 0
      || !Number.isSafeInteger(serverTime) || serverTime < 0) return;
    if (tick < this.latestTick || tick === this.latestTick && serverTime <= this.latestServerTime) return;
    this.latestTick = tick;
    this.latestServerTime = serverTime;
    this.lastProgressAt = performance.now();
  }

  public stop(): void {
    this.active = false;
    window.clearTimeout(this.timer);
    this.timer = 0;
  }

  private arm(delay: number): void {
    this.timer = window.setTimeout(this.check, delay);
  }

  private readonly check = (): void => {
    if (!this.active) return;
    const remaining = maximumAuthoritySilenceMs-(performance.now()-this.lastProgressAt);
    if (remaining > 0) { this.arm(remaining); return; }
    this.stop();
    this.expired();
  };
}
